import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userCourseDetail from "./userCourseDetailSlice";

export const fetchCourseDetails = createAsyncThunk(
  "courseDetails/fetchCourseDetails",
  async ({ apiCaller, courseId,uniqueCourseKeyInEmployeeCourses }) => {
    try {
      const response = await apiCaller.get(
        `${process.env.REACT_APP_BASE_URL}/user/getCourse`,
        { params: { courseId: courseId,uniqueCourseKeyInEmployeeCourses:uniqueCourseKeyInEmployeeCourses } }
      );
      return response?.data?.data?.courseDetail;
    } catch (err) {
      return err.message;
    }
  }
);
const courseDetailSlice = createSlice({
  name: "courseDetails",
  initialState: {
    data: {},
    userCourseDetail:[],
    isSuccess: false,
    isloading: false,
    message: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    return builder
      .addCase(fetchCourseDetails.pending, (state, action) => {
        state.isloading = true;
      })
      .addCase(fetchCourseDetails.fulfilled, (state, action) => {
        state.isloading = false;
        state.data = action.payload;
        state.isSuccess = true;
      })
      .addCase(fetchCourseDetails.rejected, (state, action) => {
        state.message = action.error.message;
        state.isloading = false;
        state.isSuccess = false;
      });
  },
});

export default courseDetailSlice;
